import { queryOptions } from "@tanstack/react-query";

import type { PurchaseOption } from "@lib/api/checkout.types";
import { omgApiClient } from "@lib/api/omgApiClient";

export interface ProductPricing {
  productId: number;
  name: PurchaseOption;
  amount: number;
  strikeThroughAmount: number;
  currency: string;
  countryCode: string;
  displayName: string | null;
  slug: string | null;
  // Populated when the user's native currency cannot process PayPal and a
  // USD fallback price exists. The checkout swaps the displayed price + the
  // Braintree drop-in's PayPal amount to USD when PayPal is selected.
  paypalPricing?: { amount: number; currency: "USD" };
  // True when the user's native currency cannot process PayPal and no USD
  // fallback exists. The Braintree drop-in hides the PayPal option entirely.
  paypalDisabled?: boolean;
}

export const getProductPricingQueryOptions = ({
  enabled,
  option,
}: {
  enabled: boolean;
  option: PurchaseOption;
}) => {
  return queryOptions({
    queryKey: ["productPricing", option],
    queryFn: async () => {
      const response = await omgApiClient.get<ProductPricing>(
        `/products/${option}`,
      );
      return response.data;
    },
    enabled,
  });
};
